import { render, staticRenderFns } from "./Service-FAQ.vue?vue&type=template&id=a8ddbdc2"
import script from "./Service-FAQ.vue?vue&type=script&lang=js"
export * from "./Service-FAQ.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports